import { createActionGroup, props } from '@ngrx/store';

import { GatewayId } from '../../../site-gateway/models/gateway';

export const SiteHistoryPageActions = createActionGroup({
    source: 'Site History Page',
    events: {
        opened: props<{ gatewayId: GatewayId }>(),
    },
});
